import React, { useEffect } from 'react'
import connect from 'libraries/front-end-core/decorators/connect'
import { requestSearchResults } from 'services/SearchService'
import PagedSearchContainer from 'redux/containers/components/search/PagedSearchContainer'
import { of, concat } from 'rxjs'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { ALL_AOLS } from 'constants/aol/aol'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import getUrl from 'libraries/front-end-core/core/url'
import { SEARCH } from 'constants/controllers'

const ConnectedPageSearch = connect(
  ({
    searchPhrase,
    searchType,
    pageNumber,
    pageLimit,
    aol,
    flavour,
    query,
    smartSearchEnabled
  }) => {
    return {
      response: concat(
        of(RESPONSE_PENDING),
        requestSearchResults({
          searchPhrase,
          searchType,
          pageNumber,
          pageLimit,
          aol,
          flavour,
          query,
          smartSearchEnabled
        })
      )
    }
  }
)((props) => <PagedSearchContainer {...props} />)

const validAols = ALL_AOLS

// Case-insensitive so links built with the old capitalized-display-name
// convention (e.g. bookmarked/shared before this changed) still validate,
// rather than being silently treated as invalid and stripped below.
const isValidAolValue = (aol) => validAols.includes(String(aol).toLowerCase())

const PagedSearchWrapper = (props) => {
  const { query, searchType, flavour } = props

  const isValidAol = Array.isArray(query.aol)
    ? query.aol.every(isValidAolValue)
    : !query.aol || isValidAolValue(query.aol)

  useEffect(() => {
    // Redirect without AOL if current AOL is invalid (backend will search all areas)
    if (!isValidAol && query.aol) {
      const newQuery = { ...query }
      delete newQuery.aol
      replaceUrl(
        getUrl(
          SEARCH,
          { flavour, searchType },
          newQuery
        )
      )
    }
  }, [isValidAol, flavour, searchType, query])

  if (!isValidAol) return null
  return <ConnectedPageSearch {...props} />
}

export default PagedSearchWrapper
